import React, { useState, useEffect} from 'react';
import axios from 'axios';
import "./TestShow.css";
import { useParams } from 'react-router-dom';
import Subscriptions from '../Subscriptions/Subscriptions';
import { END_URL } from "../../config";
import gg from "../../images/pp-logo.gif";

function SubShow({onLoginChange,userdetail,token}) {

    const subS = true;

    const [subscription, setSubscription] = useState(null);

    const [loading, setLoading] = useState(true);

    const { slug } = useParams();

    useEffect(() => {

        setLoading(true);

        const fetchSubscriptionDetail = async () => {
            try {
                
                const response = await axios.get(`${END_URL}/get-subcription/${slug}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                setSubscription(response.data);

                setLoading(false);

            } catch (error) {
                console.log('Error fetching subscription:', error);
            }
        };

        fetchSubscriptionDetail();
    }, []);


    if (loading) {

        return (
            <div
                className="loadingDiv"
            >
                <img
                src={gg}
                alt="Loading..."
                
                />
            </div>
        );
    }

    return (
        <div className="test-show-main">
            <div className="container">
                <div className="row">
                  
                    <Subscriptions subs={subS} userdetail={userdetail} Subcription={subscription} onLoginChange={onLoginChange}/>

                </div>
            </div>
        </div>
    );
}

export default SubShow;
